import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type RotateClockwiseIconProps = CreateIconComponentProps;
export const RotateClockwiseIcon: React.FC<RotateClockwiseIconProps> = ({
  title = 'RotateClockwise',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      fill="currentColor"
      d="M3.059 10.87a1 1 0 1 0 1.983.26l-1.983-.26Zm2.42 3.76a1 1 0 0 0-1.858.74l1.858-.74ZM3.05 20a1 1 0 1 0 2 0h-2Zm1-5v-1a1 1 0 0 0-1 1h1Zm5 1a1 1 0 0 0 0-2v2Zm-4.008-4.87a7 7 0 0 1 6.961-6.09l.006-2a9 9 0 0 0-8.95 7.83l1.983.26Zm6.961-6.09a7 7 0 0 1 6.925 6.131l1.985-.248a9 9 0 0 0-8.904-7.883l-.006 2Zm6.925 6.131a7 7 0 0 1-5.202 7.648l.498 1.937a9 9 0 0 0 6.689-9.833l-1.985.248Zm-5.202 7.648a7 7 0 0 1-8.247-4.19l-1.858.741a9 9 0 0 0 10.603 5.386l-.498-1.937ZM5.05 20v-5h-2v5h2Zm-1-4h5v-2h-5v2Z"
    />
  </CreateIconComponent>
);
